import { BarsIcon, CloseIcon, Moon, Sun } from "assets";
import { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { Menu } from "./Menu";
import { navItems } from "constants";
import { useLocation } from "react-router-dom";

export function NavBar({ darkMode, setDarkMode }) {
  const Icon = darkMode ? Moon : Sun;
  const [openMenu, setOpenMenu] = useState(false);
  const { pathname, hash } = useLocation();
  const activeTab = pathname + hash;

  return (
    <nav className="fixed top-0 w-full bg-nav border-b border-solid border-border z-50 backdrop-blur-md ">
      <div className="container mx-auto h-20 flex justify-between items-center">
        {/* logo */}
        <div className="flex gap-1 w-16 h-16">
          <Link to={"/#home"} smooth>
            <img
              className="w-full h-full object-cover"
              src={
                darkMode
                  ? "./dark_transparent_logo.png"
                  : "./light_mode_transparent_logo.png"
              }
              alt="SaleSpeed Logo"
            />
          </Link>
        </div>
        {/* nav links */}
        <ul className="hidden md:flex gap-8 text-muted font-semibold text-sm">
          {navItems.map((item) => (
            <li key={item.to}>
              <Link
                to={`${item.to}`}
                smooth
                className={`hover:text-accent ${activeTab === item.to ? "text-accent font-bold" : darkMode ? "text-muted" : "text-main"}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="flex gap-4 items-center">
          {/* theme switch button*/}
          <button
            className="bg-card border border-solid border-border py-2 px-4 rounded-full font-semibold text-main cursor-pointer hover:bg-white/10"
            onClick={() => setDarkMode(!darkMode)}
          >
            <Icon className="w-5 h-5 fill-yellow-500" />
          </button>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-full bg-card border border-border transition-all duration-200 hover:bg-white/10"
            onClick={() => {
              setOpenMenu(!openMenu);
            }}
          >
            {openMenu ? (
              <CloseIcon className="w-6 h-6 fill-main" />
            ) : (
              <BarsIcon className="w-6 h-6 fill-main" />
            )}
          </button>
        </div>
      </div>

      {openMenu && (
        <Menu
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          activeTab={activeTab}
          darkMode={darkMode}
        />
      )}
    </nav>
  );
}
